export default __webpack_public_path__ + "static/media/white-circled-tick.c3340c56.svg";